var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ai-panel-message"},[_c('Icon',{staticClass:"ai-panel-message__icon",attrs:{"size":"60","icon":"RobotIcon"}}),_c('v-card-title',{staticClass:"ai-panel-message__title"},[_vm._v(" Select an element first ")]),_c('p',[_vm._v("Click on an element in the editor to rewrite it with AI.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }